export const INITIATIVE_ONBOARDED = "teamManagement.initiative.onboarded";
